import { useCurrentUser } from 'components/providers'
import { createContext, useContext } from 'react'
import { useParams } from 'react-router'
import { IFacility, ITemplate } from 'types'
import { FetchStatus, deleteDoc, updateDoc, useDoc } from 'utils'
import { useFacilities, useMutateFacilityRecords } from 'utils/facilityUtils'

export interface FacilityContextProps {
  deleteFacility?: () => Promise<void>
  facility: IFacility | null
  imageUrl?: string
  status: FetchStatus
  template?: ITemplate | null
  updateFacility: (body: Partial<IFacility> & { id: string }) => Promise<void>
}

export const useFacility = () => useContext(FacilityContext)

export const FacilityContext = createContext<FacilityContextProps>({} as any)

export function FacilityProvider({ children }: { children: any }) {
  const id = useParams().id
  const user = useCurrentUser()
  const { facilities } = useFacilities()
  const { updateFacilityRecord, removeFacilityRecord } = useMutateFacilityRecords()
  const [facility, status] = useDoc('facilities', id)
  const [template] = useDoc('templates', facility?.template?.id)

  const facilityRecord = facilities?.find(f => f.id === id)

  const updateFacility = async (body: Partial<IFacility> & { id: string }) => {
    if (!user || !facility) return
    const updated = await updateDoc(user.id, 'facilities', body)
    updateFacilityRecord(updated)
  }

  const deleteFacility = async () => {
    if (!user || !facility) return
    await deleteDoc('facilities', facility.id)
    removeFacilityRecord(facility.id)
  }

  return (
    <FacilityContext.Provider
      value={{
        deleteFacility,
        facility: facility || null,
        imageUrl: facilityRecord?.imageUrl,
        status,
        template,
        updateFacility,
      }}
    >
      {children}
    </FacilityContext.Provider>
  )
}
